var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qq-map',{staticClass:"map-wrap",attrs:{"latitude":_vm.latitude,"longitude":_vm.longitude,"scale":13,"markers":_vm.markers}}),_c('page-wrap',{attrs:{"title":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }